import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { TrustBadges } from "@/components/landing/TrustBadges";
import { Benefits } from "@/components/landing/Benefits";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { CoverageTypes } from "@/components/landing/CoverageTypes";
import { Testimonials } from "@/components/landing/Testimonials";
import { Reviews } from "@/components/landing/Reviews";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileCTA } from "@/components/landing/StickyMobileCTA";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#fafafa] overflow-x-clip">
      <Header />
      <main className="pb-20 md:pb-0 overflow-x-clip">
        <Hero />
        <TrustBadges />
        <Benefits />
        <HowItWorks />
        <CoverageTypes />
        <Testimonials />
        <Reviews />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
